module.exports = __webpack_public_path__ + "static/media/passo1.56732943.jpg";